export default "__VITE_ASSET__DOoHtcCk__"